var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommentNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24.0002,
    height: 24.0002,
    rx: 12.0001,
    fill: "#FFEFD6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6123 5.6392C11.5231 5.57866 12.4751 5.57854 13.3878 5.6392C16.242 5.82893 18.5065 8.13288 18.6927 11.014C18.7276 11.553 18.7276 12.1106 18.6927 12.6496C18.5065 15.5307 16.242 17.8347 13.3878 18.0244C12.4751 18.0851 11.5231 18.0849 10.6123 18.0244C10.2592 18.0009 9.8749 17.9174 9.53653 17.7781C9.38772 17.7168 9.28671 17.6753 9.21279 17.6482C9.16196 17.6832 9.09446 17.7328 8.99616 17.8053C8.50088 18.1705 7.87559 18.4267 6.98825 18.4051L6.95966 18.4044C6.78848 18.4003 6.60602 18.3959 6.45721 18.3672C6.27798 18.3325 6.05623 18.2458 5.91745 18.0092C5.7664 17.7516 5.82696 17.4912 5.88556 17.3272C5.94086 17.1724 6.03672 16.9909 6.13465 16.8054L6.14807 16.78C6.43953 16.2276 6.52072 15.7763 6.36489 15.4753C5.84468 14.6901 5.3767 13.7223 5.30738 12.6496C5.27254 12.1106 5.27254 11.553 5.30738 11.014C5.49357 8.13288 7.75815 5.82893 10.6123 5.6392ZM9.49991 11.3752C9.15473 11.3752 8.87491 11.655 8.87491 12.0002C8.87491 12.3454 9.15473 12.6252 9.49991 12.6252H9.50552C9.8507 12.6252 10.1305 12.3454 10.1305 12.0002C10.1305 11.655 9.8507 11.3752 9.50552 11.3752H9.49991ZM11.9971 11.3752C11.6519 11.3752 11.3721 11.655 11.3721 12.0002C11.3721 12.3454 11.6519 12.6252 11.9971 12.6252H12.0027C12.3479 12.6252 12.6277 12.3454 12.6277 12.0002C12.6277 11.655 12.3479 11.3752 12.0027 11.3752H11.9971ZM14.4943 11.3752C14.1492 11.3752 13.8693 11.655 13.8693 12.0002C13.8693 12.3454 14.1492 12.6252 14.4943 12.6252H14.5C14.8451 12.6252 15.125 12.3454 15.125 12.0002C15.125 11.655 14.8451 11.3752 14.5 11.3752H14.4943Z",
    fill: "#FD9800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentNotification);
export default __webpack_public_path__ + "static/media/comment_notification.3937c5796d64b322f5b4ccb72b531053.svg";
export { ForwardRef as ReactComponent };